import './scripts/common';
import {onFind} from "@elements/init-modules-in-scope";

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init({submitOnChange: matchMedia('(max-width: 767px)').matches, addUrlParams: true});

import * as ajaxFormScrollTop from './scripts/ajax-form-scroll-top';
ajaxFormScrollTop.init();

import * as dropdownPersist from './scripts/dropdown-persist';
dropdownPersist.init();

import * as multiSelect from './scripts/multi-select';
multiSelect.init();

import * as isMobileInput from './scripts/is-mobile-input';
isMobileInput.init();

import Collapse from 'bootstrap/js/dist/collapse';
onFind('[data-bs-toggle="collapse"]',function (element) {
    new Collapse(element);
});
